import React, { PropsWithChildren, createContext } from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { createLightTheme } from './Clearly/lightTheme'
import { CustomStyles } from './types'
import { ThemeWrapper } from './ThemeWrapper'

export const ThemeContext = createContext({
  currentTheme: 'light',
})

interface ThemeProviderProps extends PropsWithChildren {
  appId: string
  brand: string
  customStyles?: CustomStyles
}

export const ThemeProvider: React.FC<ThemeProviderProps> = props => {
  const { appId, brand, customStyles, children } = props
  const theme = createLightTheme(customStyles)

  // we only support light theme
  const contextValue = {
    currentTheme: 'light',
  }

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        <ThemeWrapper appId={appId} brand={brand}>
          {children}
        </ThemeWrapper>
      </MuiThemeProvider>
    </ThemeContext.Provider>
  )
}
